<template>
  <WrapperCheckbox
    v-if="meta.attestationPiecesJustificatives?.$status === PropertyStatus.Required"
    id="field_attestationPiecesJustificatives"
    v-model="attestationPiecesJustificativesModel"
    :alertLabel="meta.attestationPiecesJustificatives?.$messageErreurDirty!"
    label="L'employeur atteste disposer de l'ensemble des pièces justificatives nécessaires au dépôt du contrat"
    :readonly
    class="col-36"
  />
  <UploadFichiers />
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { UploadFichiers } from '@/features/interface/demande/shared/components'
  import { useDemandePROAStore } from '../../useDemandePROAStore'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = useDemandePROAStore()
  const { meta, readonly } = storeToRefs(store)

  const attestationPiecesJustificativesModel = setupFieldWithKey<boolean>('attestationPiecesJustificatives', true)
</script>
